var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"horizontal-animation"},[_c('HorizontalOrange',{attrs:{"animation":_vm.animation,"loop":_vm.loop}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }